import { Component, EventEmitter, Output } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  AbstractControl,
  Validators
} from '@angular/forms';
import { AllowListUserInputModel } from '../../../../models/allow-list-user-input.model';
import {
  OsmosisErrorResponse,
  OsmosisExceptionCode
} from '../../../../models/osmosis-error-response.model';
import { AllowListUserApi } from '../../../services/allow-list-user.service';
import { ValidationService } from '../../../services/validation.service';
import { CommonSharedModule } from '../../../common/shared.module';

@Component({
  selector: 'app-add-allow-list-user',
  templateUrl: './add-allow-list-user.component.html',
  styleUrls: ['./add-allow-list-user.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class AddAllowListUserComponent {
  addAllowListUserForm!: FormGroup;
  isDialogOpen!: boolean;
  inlineMessage!: any;
  isLoading = false;
  canShowForceAdd = false;
  isForceAddOrUpdate = false;
  @Output() reload = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private allowListUserApi: AllowListUserApi
  ) {
    this.OnFormGroup();
  }

  get addAllowListUserFormControls(): Record<string, AbstractControl> {
    return this.addAllowListUserForm.controls;
  }

  OnFormGroup(): void {
    this.addAllowListUserForm = this.formBuilder.group({
      emailAddressField: [
        '',
        [
          Validators.required,
          Validators.email,
          this.validationService.noWhitespaceValidator
        ]
      ],
      fullNameField: [
        '',
        [Validators.required, this.validationService.noWhitespaceValidator]
      ],
      mpnIdField: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(15),
          Validators.pattern('^[0-9]*$'),
          this.validationService.noWhitespaceValidator,
          this.validationService.isInteger32
        ]
      ],
      isForceAddOrUpdateField: ['']
    });
  }

  showDialog(): void {
    this.isDialogOpen = true;
    this.isForceAddOrUpdate = false;
  }

  closeDialog(): void {
    this.isDialogOpen = false;
    this.addAllowListUserForm.reset();
    this.inlineMessage = [];
    this.canShowForceAdd = false;
    this.isForceAddOrUpdate = false;
  }

  onSubmitUserInformation(): void {
    this.isLoading = true;
    const allowListUserInfo: AllowListUserInputModel = {
      mpnId: this.addAllowListUserForm.controls['mpnIdField'].value.trim(),
      fullName:
        this.addAllowListUserForm.controls['fullNameField'].value.trim(),
      primaryEmail:
        this.addAllowListUserForm.controls['emailAddressField'].value.trim(),
      isForceAddOrUpdate: this.isForceAddOrUpdate
    };

    this.allowListUserApi.addUserToAllowList(allowListUserInfo).subscribe(
      () => {
        this.showMessage(
          'Successfully Added/Updated User To Allowed List',
          'success'
        );
        this.isLoading = false;
        this.closeDialog();
        this.reload.emit(true);
      },
      errorResponse => {
        this.isLoading = false;
        if (errorResponse && errorResponse.error) {
          const error: OsmosisErrorResponse = errorResponse.error;
          this.showMessage(error.errorInfo, 'error');
          this.canShowForceAdd =
            error.detailedStatusCode == OsmosisExceptionCode.AlreadyExists ||
            error.detailedStatusCode ==
              OsmosisExceptionCode.MpnIdDomainMismatch;
        }
      }
    );
  }

  showMessage(message: string, severity: string): void {
    this.inlineMessage = [{ severity: severity, detail: message }] as any;
  }
}
